// IMPORTANT: After modifying this file, update CHANGELOG.md with a summary of your changes.
// Add clear comments for non-obvious changes, including what replaced prior behavior, to avoid repeating failed fixes.

// Site-wide "[ LABEL ]" tag in stone-600, same classes as StatsGrid. Moved
// out of FaqBlock (where it was private) so other blocks with identical
// label markup can share it. Blocks whose label uses a different color
// (opichi-muted on the #102/#103 light sections, green on the dark bands)
// keep their own markup on purpose.
export function SectionLabel({ text }: { text?: string }) {
  if (!text) return null;
  return (
    <div className="text-sm uppercase tracking-widest text-stone-600 mb-4">
      [ {text} ]
    </div>
  );
}
